import { Component, h, Prop } from '@stencil/core';


@Component({
    tag: 'lilu-brand-slider-tile',
    styleUrl: 'lilu-brand-slider-tile.scss',
    shadow: true
})
export class LiluBrandSliderTile {

  @Prop() urlTo: string;
  @Prop() imgMobile: string;
  @Prop() imgDesktop: string;
  @Prop() imgAlt: string;
  @Prop() headline: string;

  render() {
    return (
      <a class="brand-slider-tile" href={this.urlTo}>
        <div class="brand-slider-tile__img">
          <lilu-img src={`${this.imgDesktop}`} srcset={`${this.imgMobile}`} alt={`${this.imgAlt}`}></lilu-img>
        </div>
        <lilu-heading color="nero" level="5">{this.headline}</lilu-heading>
      </a>
    );
  }
}
